import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["entityType", "civilityField", "companyNameField", "personalInfoSection"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const entityType = this.entityTypeTarget.value
    
    if (entityType === 'natural_person') {
      this.civilityFieldTarget.classList.remove('d-none')
      this.companyNameFieldTarget.classList.add('d-none')
      if (this.hasPersonalInfoSectionTarget) {
        this.personalInfoSectionTarget.querySelector('.section-title')?.remove()
      }
    } else if (entityType === 'legal_entity') {
      this.civilityFieldTarget.classList.add('d-none')
      this.companyNameFieldTarget.classList.remove('d-none')
      if (this.hasPersonalInfoSectionTarget && !this.personalInfoSectionTarget.querySelector('.section-title')) {
        const title = document.createElement('h6')
        title.className = 'section-title mt-3 mb-2 text-muted'
        title.textContent = 'Administrateur de la société'
        this.personalInfoSectionTarget.insertBefore(title, this.personalInfoSectionTarget.firstChild)
      }
    }
  }
}

